import React, { Component } from 'react';
import { setTimeout } from 'timers';
import { connect } from 'react-redux';
import { destroyAlert } from '../actions/alertActions';
import { withRouter } from 'react-router-dom';

//const Closer = (props) => {
//    if (props.dismissible) {
//        return (<a href="javascript:void(0)" onClick={props.onClick} className="close ml-md">&times;</a>);
//    }
//    return (null);
//}

export class Alert extends Component {
    constructor(props) {
        super(props);
        this.state = { visible: true };
        this.hide = this.hide.bind(this);
        this.autoClose = this.autoClose.bind(this);
    }
    componentDidMount() {
        this.autoClose();
    }

    hide() {
        this.setState({ visible: false });
        this.props.onClose();
    }

    autoClose() {
        if (this.props.timeout) {
            //console.log('will time out');
            setTimeout(() => {
                this.hide()
            }, this.props.timeout);
        }
    }

    render() {
        const closer = this.props.timeout ? null : <button className="close ml-md" onClick={this.hide}>&times;</button>
        if (this.state.visible) {
            return (
                <div className={this.props.className}>
                    {closer}
                    {this.props.children}
                </div>
            )
        }
        return (null);
    }
}

class AlertStack extends Component {
    render() {
        const alerts = this.props.alerts.map(alert => <Alert key={alert.id} className={`alert ${alert.className}`} onClose={() => this.props.destroyAlert(alert.id)} timeout={alert.timeout}>{alert.children}</Alert>);
        return (<div className={this.props.className}>{alerts}</div>)
    }
}

const mapStateToProps = (state) => ({
    alerts: state.alerts.alerts
});

export default withRouter(connect(mapStateToProps, { destroyAlert })(AlertStack));
